import { _ as i } from "./_castSlice.js";
import { _ as c } from "./_hasUnicode.js";
import { _ as s } from "./_stringToArray.js";
import { t as n } from "./toString.js";
var m = i, _ = c, f = s, l = n;
function p(t) {
  return function(r) {
    r = l(r);
    var a = _(r) ? f(r) : void 0, o = a ? a[0] : r.charAt(0), e = a ? m(a, 1).join("") : r.slice(1);
    return o[t]() + e;
  };
}
var h = p;
export {
  h as _
};
//# sourceMappingURL=_createCaseFirst.js.map
